import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store/authStore';

export function HomeRedirect() {
  const user = useAuthStore(s => s.user);

  if (!user) return <Navigate to="/login" replace />;

  const { role, department } = user;

  if (role === 'SUPER_ADMIN') {
    return <Navigate to="/departments" replace />;
  }

  if (department?.code) {
    return <Navigate to={`/${department.code.toLowerCase()}/dashboard`} replace />;
  }

  return <Navigate to="/departments" replace />;
}
